// Script to dynamically update the Sub-style drop-down and base-configuration on product-page.

document.addEventListener("DOMContentLoaded", () => {
  const selectElement = document.getElementById("sub-style");
  const baseConfigTwo = document.querySelector("#base-config-two");
  const fullUrl = window.location.href;
  const extracted_handle = fullUrl.split("products/")[1]?.split("-")[0]; // Extract handle: 'armchair', 'chaise', etc.
  let check = true;

  // Only for Drop-down  (Sofa & Storage product)
  if (selectElement) {
    for (const option of selectElement.options) {
      const optionText = option.textContent.trim();
      const menu = option.dataset.menu;
  
      if (optionText == menu) {
          option.selected = true;
          const [product_reference, buttonImages] = option.value.split("|");
          const config_value = option.dataset.value;
          update_base_config(product_reference, buttonImages, config_value);
          check = false;

          break; 
      }
  }

    // For storage
    if (check) {
      const match = fullUrl.match(/\/products\/([^?]+)/);
      const handle = match ? match[1].replace(/-/g, " ") : null;
      Array.from(selectElement.options).forEach((option) => {
        if (handle?.includes(option.textContent.toLowerCase().trim())) {
          option.selected = true;
          const [product_reference, buttonImages] = option.value.split("|");
          const config_value = option.dataset.value;
          update_base_config(product_reference, buttonImages, config_value);
        }
      });
    }
  }

  if (baseConfigTwo) {
    const match = fullUrl.match(/\/products\/([^?]+)/);
    const productHandle = match ? match[1] : null;
    baseConfigTwo.querySelectorAll("li").forEach((li) => {
      let name = li.dataset.name;
      let value = li.dataset.value;
      li.classList.remove("selected");
      if (name == productHandle) {
        li.classList.add("selected");
        update_selected_base_config(value, "base-config-selected-two");
      }
    });
  }

  baseConfigTwo?.addEventListener("click", (event) => {
    const clickedLi = event.target.closest("li");
    if (!clickedLi) return;
    let value = clickedLi.dataset.value;
    let name = clickedLi.dataset.name;
    localStorage.setItem("base-config-two", name);
    baseConfigTwo
      .querySelectorAll("li")
      .forEach((li) => li.classList.remove("selected"));
    clickedLi.classList.add("selected");
    // const match = fullUrl.match(/\/products\/([^?]+)/);
    // const productHandle = match ? match[1] : null;
    update_selected_base_config(value, "base-config-selected-two");
    re_route_handler(name);
  });
});

// Function to handle dropdown changes
function handleSelectChange(selectElement) {
  const [product_reference, buttonImages] = selectElement.value.split("|");
  const selectedOption = selectElement.selectedOptions[0]; // Get the selected option
  const config_value = selectedOption.dataset.value;
  update_base_config(product_reference, buttonImages, config_value);
  document.querySelector("#base-config-selected").innerText = "";
}

// Function to update base configuration
function update_base_config(product_reference, button_images, config_value) {
  const parsed_product_data = JSON.parse(product_reference);
  const image_list = button_images
    .split(",")
    .filter((value) => value.length > 5)
    .map((src) => src.replace(/^"/, ""));

  const value_list = config_value
    .split(",")
    .map((src) => src.replace(/^"/, "").trim());

  const baseConfig = document.getElementById("base-config");
  if (!baseConfig) return;

  const ul = document.createElement("ul");
  // const handle = localStorage.getItem("handle");
  const match = window.location.href.match(/\/products\/([^?]+)/);
  const handle = match ? match[1] : null;

  parsed_product_data.forEach((product, index) => {
    const li = document.createElement("li");
    const img = document.createElement("img");
    img.src = image_list[index];

    if (handle === product.handle) {
      document
        .querySelectorAll("#base-config li")
        .forEach((li) => li.classList.remove("selected"));
      li.classList.add("selected");
      update_selected_base_config(value_list[index], "base-config-selected");
    }

    li.appendChild(img);
    li.addEventListener("click", () => {
      document
        .querySelectorAll("#base-config li")
        .forEach((li) => li.classList.remove("selected"));
      li.classList.add("selected");
      update_selected_base_config(value_list[index], "base-config-selected");
      // localStorage.setItem("handle", product.handle);
      re_route_handler(product.handle);
    });

    ul.appendChild(li);
  });

  baseConfig.innerHTML = "";
  baseConfig.appendChild(ul);
}

// Function to handle re-routing
function re_route_handler(handle) {
  const location = `/products/${handle}`;
  if (window.location.pathname !== location) {
    window.location.href = location;
  }
}

// Function to update selected base configuration title
function update_selected_base_config(value, id) {
  const element = document.getElementById(id);
  if (element) {
    element.textContent = value;
  }
}
